import React from "react";
import styled from "styled-components";

// Aspect ratio is locked so the frame never shifts the layout while the image loads
const Frame = styled.div`
  aspect-ratio: 1170 / 2532;
  width: ${(props) => props.$width};
  flex-shrink: 0;
  border: 8px solid #141414;
  border-radius: 44px;
  overflow: hidden;
  background: #141414;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

const PhoneFrame = React.forwardRef(
  ({ src, alt, priority = false, width = "min(300px, 70vw)", ...rest }, ref) => (
    <Frame ref={ref} $width={width} {...rest}>
      <img
        src={src}
        alt={alt}
        width="1170"
        height="2532"
        decoding="async"
        loading={priority ? "eager" : "lazy"}
        fetchpriority={priority ? "high" : undefined}
      />
    </Frame>
  )
);

export default PhoneFrame;
